var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSky2Mountains(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1998.19 734.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #aedde1;\n      }\n\n      .cls-2 {\n        fill: #94dbdd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1998.19,0v571.42H4.68V190.73l232.26-64.64,64.86-33.45,109.24,17.61,108.98,91.31,40.24-15.01,46.7-17.42,60.07,14.19,38.51,36.37,61.96,3.55,49.37,53.65,128.58,20.5,109.02-65.21c23.4-14,52.8-18.87,80.74-13.37l83.65,16.46,175.9-76.14,64.83-19.66,30.81-30.51,61.75-5.62,143.29,54.35,41.65-32.87,82.27-17.59,95.53-79.84L1998.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.88,0L0,723.47l1996.39,10.61V255.14l-232.26-86.47-64.86-44.75-109.24,23.56-108.98,122.15-40.24-20.07-27.2-28.61c-12.29-12.93-34.71-13.95-48.48-2.2l-31.09,26.5-38.51,48.65-33.75,2.59c-17.72,1.36-33.61,10.01-42.72,23.26l-34.86,50.67-128.58,27.42-96.44-62.5c-15.75-10.21-34.71-16.02-54.36-16.65l-122.62-3.95-175.9-101.86-64.83-26.3-22.29-39.98c-7.36-13.21-24.64-19.87-40.88-15.78l-29.38,7.41-143.29,72.7-41.65-43.97-82.27-23.54L86.18,36.63,2.88,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSky2Mountains);
export default __webpack_public_path__ + "static/media/SKY2_MOUNTAINS.769af7335fd0f793b2cd6be3a70a37f6.svg";
export { ForwardRef as ReactComponent };